// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"d3089c36","124":"fe1bac4b","320":"297faa02","373":"cb84cec4","453":"eb0fd619","523":"ed93a041","682":"69ceac63","752":"e5d29e2e","892":"405ab1ee","905":"729707b3","942":"4e30bb0b"}[chunkId] + ".chunk.js";
};